import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  props: ['editedRole'],
  components: {
    MenuComponent,
    BlocAuthenticated
  },
  data () {
    return {
      listPermissionsForRole: {},
      loading: false,
      moduleErrorMessage: '',
      otherErrorMessage: ''
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Détails du role'
    this.$store.state.filArianeMiddlePage = 'Liste des roles'
    this.$store.state.filArianeMiddleRouterLink = 'administration/role/list'
  },
  mounted () {
    if (!this.editedRole) {
      this.$router.push({ name: 'administration/role/list' })
    } else {
      this.loading = true
      this.$store.dispatch('xarm/getPermissionsForRole', this.editedRole.rm_role.name).then(
        response => {
          this.listPermissionsForRole = response.data
          this.loading = false
        },
        error => {
          this.errorMessage = error.response.data
          this.loading = false
        }
      )
    }
  },
  methods: {
    treatPermission (permissionName, permissionPlace) {
      this.moduleErrorMessage = ''
      this.otherErrorMessage = ''
      this.loading = true
      let permissionAndRoleName = permissionName + '|' + this.editedRole.rm_role.name
      this.$store.dispatch('xarm/addOrRemovePermissions', permissionAndRoleName).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          if (permissionPlace === 'module') {
            this.moduleErrorMessage = error.response.data
          } else {
            this.otherErrorMessage = error.response.data
          }
          this.loading = false
        }
      )
    }
  }
}
